import { useCallback } from 'react'
import { BigNumber } from 'bignumber.js'

// utils
import {
  getDishMasterContract,
  getDishContract,
  getAllStakingDishToken,
  getAllStakingDishTokenV2,
  // getAllUnstakingDishToken,
  getDishInfo,
  getComboNFTCommonStakeERC721EarnBake2Contract,
  getNftHelperContract,
  getErc721Balance,
  getComboNFTCommonStakeERC721EarnBake3Contract
} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '../'
import useUserBids from '../nft/useUserBids'
import useUserAsks from '../nft/useUserAsks'
import { NFTTYPE } from '../../constants/bakery/nft'
import { userNftAddress } from '../../userType/userNftAddress'

const useAllDishes = (onlyUnstaking?: boolean, gameType?: string, type?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let dishMasterContract1 = getDishMasterContract(sushi)
  let dishMasterContract2 = getComboNFTCommonStakeERC721EarnBake2Contract(sushi)
  let dishMasterContract3 = getComboNFTCommonStakeERC721EarnBake3Contract(sushi)
  const nftHelper = getNftHelperContract(sushi)
  const nftAddress = userNftAddress(sushi, type)

  const dishContract = getDishContract(sushi)

  const userBids = useUserBids(type)
  const userAsks = useUserAsks(type)
  const getAllDishes = useCallback(async (noNeed?: boolean) => {
    let allStakingDishes1 = [] // 当前合约质押
    let allStakingDishes2 = [] // 另一个合约质押
    if(gameType === NFTTYPE.COMBO_V3){
      allStakingDishes1 = onlyUnstaking ? [] : await getAllStakingDishTokenV2(dishMasterContract3, dishMasterContract1, account)
      const allStakingDishes2_1 = onlyUnstaking ? [] : await getAllStakingDishToken(dishMasterContract1, account)
      const allStakingDishes2_2 = onlyUnstaking ? [] : await getAllStakingDishTokenV2(dishMasterContract2, dishMasterContract1, account)
      allStakingDishes2 = [...allStakingDishes2_1, ...allStakingDishes2_2]
      // console.log("--allStakingDishes2_1--",allStakingDishes2_1)
      // console.log("--allStakingDishes2_2--",allStakingDishes2_2)
      // console.log("--allStakingDishes2--",allStakingDishes2)
    }else{
      const allStakingDishes1_1 = onlyUnstaking ? [] : await getAllStakingDishToken(dishMasterContract1, account)
      const allStakingDishes1_2 = onlyUnstaking ? [] : await getAllStakingDishTokenV2(dishMasterContract2, dishMasterContract1, account)
      allStakingDishes1 = [...allStakingDishes1_1, ...allStakingDishes1_2]
      allStakingDishes2 = onlyUnstaking ? [] : await getAllStakingDishTokenV2(dishMasterContract3, dishMasterContract1, account)
    }

    // const allUnstakingDishes = onlyUnstaking ? [] : await getAllUnstakingDishToken(dishMasterContract1, dishContract, account)

    const allMyArtworks = onlyUnstaking ? [] : await getErc721Balance(nftHelper, nftAddress, account) // 钱包
    const allMyAsks = onlyUnstaking ? [] : await userAsks()
    const allMyBids= await userBids()

    const asks: any[] = await Promise.all(allMyAsks.map(async (d: any[]) => {
      const dishInfo = await getDishInfo(dishMasterContract1, d[0])

      return {
        ...dishInfo,
        price: new BigNumber(d[1]).div(new BigNumber(10).pow(18)).toString(),
        exchange: true
      }
    }))
    const bids: any[] = await Promise.all(allMyBids.map(async (d: any[]) => {
      const dishInfo = await getDishInfo(dishMasterContract1, d[0])
      return {
        ...dishInfo,
        price: new BigNumber(d[1]).div(new BigNumber(10).pow(18)).toString(),
        exchange: true
      }
    }))
    const wattles: any[] = await Promise.all(allMyArtworks.map(async (d: any[]) => {
      const dishInfo = await getDishInfo(dishMasterContract1, d)
      return {
        ...dishInfo,
        price: new BigNumber(d[1]).div(new BigNumber(10).pow(18)).toString(),
        exchange: false
      }
    }))
    // 当前版本质押
    for(let i = 0;i < allStakingDishes1.length;i++){
      allStakingDishes1[i].staking = true
    }

    // 另一个版本版本质押
    for(let i = 0;i < allStakingDishes2.length;i++){
      allStakingDishes2[i].staking2 = true
    }

    const arr = [
      ...bids.reverse(),
      // ...allStakingDishes1.reverse(),
      // ...allStakingDishes2.reverse(),
      // ...allUnstakingDishes.reverse(),
      ...asks.reverse()
    ]


    if (!noNeed) {
      arr.push(
        ...allStakingDishes1.reverse(),
        ...allStakingDishes2.reverse(),
        ...wattles
      )
    }

    return arr
  }, [account, dishMasterContract1,dishMasterContract2,dishMasterContract3,getAllStakingDishTokenV2,getAllStakingDishToken, gameType, dishContract, onlyUnstaking, userBids])

  return getAllDishes
}

export default useAllDishes
